<template>
    <button class="group relative flex flex-col" @click="onOpenModal">
        <span class="w-full">
            <span
                class="block rounded-xl p-4 ring-1 ring-inset ring-grind-200 transition group-hover:ring-3 group-hover:ring-grind"
            >
                <img
                    src="~/assets/images/color-wheel.svg"
                    class="h-full w-full object-cover"
                />
            </span>
            <span class="mt-1.5 flex flex-col items-center"
                >Custom printed</span
            >
        </span>
    </button>

    <Modal ref="basicModal">
        <template #title>We are sending you to the custom quote page.</template>

        <p>
            If blank is not quite what you’re looking for, or you’d like to
            compare our blank products to fully custom printed packaging, our
            instant quote tool will let you build a custom packaging project
            exactly to your liking.
        </p>

        <template #actions>
            <button class="btn-secondary" @click.prevent="basicModal?.close">
                Cancel
            </button>

            <NuxtLink :href="customProductPageUrl" class="btn-primary">
                Get a quote
            </NuxtLink>
        </template>
    </Modal>

    <Modal ref="designLabModal" :show-action-buttons="false">
        <template #title>How would you like to customize your bag?</template>

        <div class="grid grid-cols-2 gap-6 md:gap-12">
            <NuxtLink
                to="/design-lab"
                class="group text-center text-grind no-underline"
            >
                <img
                    src="~/assets/images/product-page/custom-design-modal-design-lab.webp"
                    alt="Design Lab illustration"
                    class="aspect-[4/3] rounded-lg object-contain ring-1 ring-inset ring-grind/20 transition-all group-hover:ring-3 group-hover:ring-grind"
                />
                <div class="mt-2.5">Roastar Design Lab</div>
                <div class="text-xs text-grind/80">
                    Personalize a free template
                </div>
            </NuxtLink>

            <NuxtLink
                :to="getQuoteUrl"
                class="group text-center text-grind no-underline"
            >
                <img
                    src="~/assets/images/product-page/custom-design-modal-custom-printed.webp"
                    alt="Custom printed illustration"
                    class="aspect-[4/3] rounded-lg object-contain p-3 ring-1 ring-inset ring-grind/20 transition-all group-hover:ring-3 group-hover:ring-grind"
                />
                <div class="mt-2.5">Custom Printed</div>
                <div class="text-xs text-grind/80">
                    Use our custom quote tool
                </div>
            </NuxtLink>
        </div>
    </Modal>
</template>

<script setup lang="ts">
import Modal from '~/components/Modal.vue';

const basicModal = ref<InstanceType<typeof Modal> | undefined>();
const designLabModal = ref<InstanceType<typeof Modal> | undefined>();

const props = defineProps<{
    customProductPageUrl: string;
    isAvailableInDesignLab: boolean;
}>();

const onOpenModal = () => {
    if (props.isAvailableInDesignLab) {
        designLabModal.value?.open();
    } else {
        basicModal.value?.open();
    }
};

const getQuoteUrl = computed(() => {
    const quoteProductType = props.customProductPageUrl.includes('tin-can')
        ? 'can'
        : 'bag';

    return `/get-quote#productType=${quoteProductType}`;
});
</script>
